import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const UnitFilters = ({ filters, onFilterChange }) => {
  const handleFilterChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  const selectStyles = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "0.5rem",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E5E7EB",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#5652B0",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#5652B0",
    },
  };

  return (
    <div className="flex items-center gap-4 flex-wrap">
      {/* Unit Type Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Unit Type</InputLabel>
        <Select
          value={filters.type}
          label="Unit Type"
          onChange={e => handleFilterChange("type", e.target.value)}
          sx={selectStyles}>
          <MenuItem value="ALL">All Types</MenuItem>
          <MenuItem value="BASE">Base Units</MenuItem>
          <MenuItem value="COMPOSITE">Composite Units</MenuItem>
          <MenuItem value="TERTIARY">Tertiary Units</MenuItem>
        </Select>
      </FormControl>

      {/* Category Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Category</InputLabel>
        <Select
          value={filters.category}
          label="Category"
          onChange={e => handleFilterChange("category", e.target.value)}
          sx={selectStyles}>
          <MenuItem value="ALL">All Categories</MenuItem>
          <MenuItem value="COUNT">Count</MenuItem>
          <MenuItem value="WEIGHT">Weight</MenuItem>
          <MenuItem value="VOLUME">Volume</MenuItem>
          <MenuItem value="LENGTH">Length</MenuItem>
          <MenuItem value="AREA">Area</MenuItem>
          <MenuItem value="PACKAGING">Packaging</MenuItem>
          <MenuItem value="OTHER">Other</MenuItem>
        </Select>
      </FormControl>

      {/* Sort By Filter */}
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Sort By</InputLabel>
        <Select
          value={filters.sortBy}
          label="Sort By"
          onChange={e => handleFilterChange("sortBy", e.target.value)}
          sx={selectStyles}>
          <MenuItem value="">None</MenuItem>
          <MenuItem value="name_asc">Name (A-Z)</MenuItem>
          <MenuItem value="name_desc">Name (Z-A)</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default UnitFilters;
